// extracted by mini-css-extract-plugin
export default {"container":"EmailRecipients_container__JAy3Q","to":"EmailRecipients_to__+KDWL","recipient":"EmailRecipients_recipient__PxPhV","email":"EmailRecipients_email__wXYlp"};